import { placeholderImages } from 'axl-config';

// Builds the object structure that is passed into Westlake's API
const getWestlakeApiObject = ({
    id,
    make,
    owner = {},
    model,
    trim,
    year,
    vin,
    images = {},
    pricingDetail: {
        salePrice, msrp,
    } = {},
    mileage = {},
    stockNumber: stockNo,
    clickType,
}) => {
    const imageUrl = Object.keys(images).length ? images.sources[images.primary].src : placeholderImages.noImageAvailable;

    return {
        year,
        make: String(make?.name ?? make),
        model: String(model?.name ?? model),
        trim: String(trim?.name ?? trim),
        vin,
        stockNo,
        dealerid: String(owner?.id),
        id,
        imageUrl,
        mileage: Number(mileage?.value?.replace(/\D/g, '')),
        price: salePrice || msrp,
        primaryColor: '#9D001D',
        ...(!!clickType && { clickType }),
    };
};

export default getWestlakeApiObject;
